// 1. 외부 패키지
import { useRecoilValue } from "recoil";

// 2. 프로젝트 내부 alias


// 3. 상대 경로
import item1 from '../../static/img/icons/info-item13.svg'
import item2 from '../../static/img/icons/info-item1.svg'
import item3 from '../../static/img/icons/info-item7.svg'
import item4 from '../../static/img/icons/info-item6.svg'
import { tableData, onChangeToggleTypeValue, onChangeToggleTypeUnit } from '../../shared/function'
import get_basic_detail_selector from '../../selector/get-basic-detail-selector'
import { getQuery } from '../../shared/function'
import basic_detail_atom from "../../atom/basic-detail";

// 4. 타입

const Table = () => {

	const data = useRecoilValue(get_basic_detail_selector(getQuery().idx));

	const { area_type } = useRecoilValue(basic_detail_atom);

	const toggle_type = area_type === 'PY' ? 'left' : 'right';

	const { detail } = data;

	let table_data = [
		{
			icon: item1,
			name: '진행현황',
			text: <><strong>{tableData(detail.bunyang_status)}</strong></>
		}, {
			icon: item2,
			name: '면적',
			text: <><strong>{onChangeToggleTypeValue(toggle_type, detail.area) || '0'}</strong>{onChangeToggleTypeUnit(toggle_type)}</>
		}, {
			icon: item3,
			name: '사업기간',
			text: <><strong>{tableData(detail.project_period)}</strong></>
		}, {
			icon: item4,
			name: '평당 분양가',
			text: <><strong>{tableData(detail.price_bunyang_txt)}</strong></>
		}
	];

	return (
		<ul className='detail_info_items'>
			{table_data.map((i, index) => {
				return (
					<li key={index}>
						<div className='item_title'>
							<img src={i.icon} alt={i.name} />
							{i.name}
						</div>
						<div className='item_desc'>
							{i.text}
						</div>
					</li>
				);
			})}
		</ul>
	);
};

export default Table;